import * as React from 'react';

import type { WrappedComponentProps, IntlShape } from 'react-intl-next';
import { injectIntl } from 'react-intl-next';
import { FlagGroup, AutoDismissFlag } from '@atlaskit/flag';
import ErrorIcon from '@atlaskit/icon/glyph/cross-circle';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import messages from './messages';

interface RequestFeedbackErrorProps {
    errorType: string;
    onErrorFlagDismiss: () => void;
}

export class RequestFeedbackError extends React.Component<RequestFeedbackErrorProps & WrappedComponentProps> {
    render() {
        const { errorType, intl, onErrorFlagDismiss } = this.props;
        const { title, description } = getIntlErrorFor(errorType, intl);
        return (
            <FlagGroup onDismissed={onErrorFlagDismiss}>
                <AutoDismissFlag
                    id="request-feedback-error-flag"
                    icon={
                        <ErrorIcon
                            primaryColor={token('color.icon.danger', colors.R500)}
                            label="error-with-feedback-submit"
                        />
                    }
                    title={title}
                    description={description}
                />
            </FlagGroup>
        );
    }
}

function getIntlErrorFor(errorType: string, intl: IntlShape) {
    switch (errorType) {
        case 'star-rating-submit':
            return {
                title: intl.formatMessage(messages.RatingSubmissionErrorTitle),
                description: intl.formatMessage(messages.RatingSubmissionErrorDescription),
            };
        case 'comment-submit':
            return {
                title: intl.formatMessage(messages.CommentSubmissionErrorTitle),
                description: intl.formatMessage(messages.CommentSubmissionErrorDescription),
            };
        default:
            throw new Error(`"${errorType}" is not a valid error type for the customer request feedback form`);
    }
}

export default injectIntl(RequestFeedbackError);
